import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmptyStateComponent {
    @Input() imageType: 'empty' | 'verification' = 'empty';
}
